import React, { useMemo, useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import { cardsStore } from '../../store/cardsStore';
import { CARD_HAND_TYPES } from '../../enums/cardTypes';
import { roundActiveHandStore } from '../../store/roundActiveHandStore';
import CurrentHandCards from '../currentHandCards';
import { gameStore } from '../../store/gameStore';

const PlayerCardsSection = observer(() => {
  const { firstHandInfo, secondHandInfo } = roundActiveHandStore;
  const {
    playerCards,
    selectedCardBackSideType,
    selectedCardType,
    cardsTotalPointByHand,
    isDarkCardOpened,
  } = cardsStore;
  const { isAnimationOn } = userSettingsStore;
  const { betId, splitBetId } = gameStore;

  const [delayedCards, setDelayedCards] = useState(playerCards);
  const isActive = useMemo(() => Boolean(betId || splitBetId), [betId, splitBetId]);

  useEffect(() => {
    if (betId) {
      setDelayedCards(playerCards);
    } else {
      const timer = setTimeout(() => {
        setDelayedCards(
          playerCards.slice(0, 2).map((card) => ({
            ...card,
            showCard: true,
            handType: CARD_HAND_TYPES.firstHand,
          }))
        );
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [playerCards, betId]);

  const playerCardsByHands = useMemo(() => {
    const cards = isActive ? playerCards : delayedCards;

    return {
      [CARD_HAND_TYPES.firstHand]: cards.filter(
        (card) => card.handType === CARD_HAND_TYPES.firstHand
      ),
      [CARD_HAND_TYPES.secondHand]: cards.filter(
        (card) => card.handType === CARD_HAND_TYPES.secondHand
      ),
    };
  }, [playerCards, isActive, delayedCards]);

  if (!playerCards.length) {
    return null;
  }

  return (
    <div className={`${isMobile() ? 'm-' : ''}card-player-panel`}>
      {!!playerCardsByHands[CARD_HAND_TYPES.secondHand].length && (
        <CurrentHandCards
          isActive={!betId || isDarkCardOpened}
          isRoundFin={isDarkCardOpened}
          handInfo={secondHandInfo}
          isAnimationOn={isAnimationOn}
          selectedCardType={selectedCardType}
          selectedCardBackSideType={selectedCardBackSideType}
          playerCardsByHands={playerCardsByHands[CARD_HAND_TYPES.secondHand]}
          cardsTotalPoint={cardsTotalPointByHand[CARD_HAND_TYPES.secondHand]}
        />
      )}
      <CurrentHandCards
        isActive={betId || isDarkCardOpened}
        isRoundFin={isDarkCardOpened}
        handInfo={firstHandInfo}
        isAnimationOn={isAnimationOn}
        selectedCardType={selectedCardType}
        selectedCardBackSideType={selectedCardBackSideType}
        playerCardsByHands={playerCardsByHands[CARD_HAND_TYPES.firstHand]}
        cardsTotalPoint={cardsTotalPointByHand[CARD_HAND_TYPES.firstHand]}
      />
    </div>
  );
});

export default PlayerCardsSection;
